export default __webpack_public_path__ + "static/media/placeholder_store01-nl-mobile.a18a1f19.png";